<template>
  <div class="carousel-container">
    <carousel-skeleton v-if="loading" />
    
    <div v-else class="carousel">
      <transition-group name="fade">
        <div 
          v-for="(slide, index) in slides" 
          :key="slide.id"
          v-show="currentIndex === index"
          class="slide"
        >
          <img :src="slide.image" :alt="slide.title" class="slide-image">
          <div class="slide-content">
            <h2 class="slide-title">{{ slide.title }}</h2>
          </div>
        </div>
      </transition-group>
      
      <div class="carousel-indicators">
        <div 
          v-for="(slide, index) in slides" 
          :key="`dot-${slide.id}`"
          class="indicator"
          :class="{ active: currentIndex === index }"
          @click="setCurrentIndex(index)"
        ></div>
      </div>
      
      <button class="carousel-control prev" @click="prev">
        <span class="arrow left"></span>
      </button>
      <button class="carousel-control next" @click="next">
        <span class="arrow right"></span>
      </button>
    </div>
  </div>
</template>

<script>
import CarouselSkeleton from './CarouselSkeleton.vue';

export default {
  name: 'ImageCarousel',
  components: {
    CarouselSkeleton
  },
  props: {
    slides: {
      type: Array,
      required: true
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    interval: {
      type: Number,
      default: 5000
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null
    }
  },
  mounted() {
    if (this.autoplay && !this.loading) {
      this.startAutoplay();
    }
  },
  watch: {
    loading(newVal) {
      if (!newVal && this.autoplay) {
        this.startAutoplay();
      } else if (newVal) {
        this.stopAutoplay();
      }
    }
  },
  beforeUnmount() {
    this.stopAutoplay();
  },
  methods: {
    startAutoplay() {
      this.stopAutoplay(); // Clear any existing timer
      this.timer = setInterval(() => {
        this.next();
      }, this.interval);
    },
    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    },
    setCurrentIndex(index) {
      this.currentIndex = index;
    }
  }
}
</script>

<style scoped>
.carousel-container {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 400px;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.slide-content {
  position: absolute;
  bottom: 35%;
  left: 0;
  width: 100%;
  padding: 0 50px;
  color: white;
  text-align: center;
}

.slide-title {
  font-size: 36px;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}

.indicator.active {
  width: 60px;
  height: 10px;
  border-radius: 5px;
  /* background-color: white; */
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}

.carousel-control:hover {
  background-color: rgba(255, 255, 255, 0.8);
}

.prev {
  left: 20px;
}

.next {
  right: 20px;
}

.arrow {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-top: 2px solid #333;
  border-right: 2px solid #333;
}

.left {
  transform: rotate(-135deg);
}

.right {
  transform: rotate(45deg);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style> 